// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__FJV2E","productName":"Table_productName__2BqfV"};